import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetPR_AdministrativeCostsByPR_AdministrativeCosts = createAsyncThunk(
  "dropdowns/GetPR_AdministrativeCostsByPR_AdministrativeCosts",
  async (Parameter, { rejectWithValue }) => {
    console.log("sdsdssaccascdsdsdsd");
    
    try {
      
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_AdministrativeCostsController/GetPR_AdministrativeCostsByPR_AdministrativeCosts",Parameter
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PRAdministrativeCostsReducers = createSlice({
  name: "TypeOfJobOpportunityDropDown",
  initialState: {
    PRAdministrativeCosts: [],
    loadingPRAdministrativeCosts: false,
    errorPRAdministrativeCosts: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetPR_AdministrativeCostsByPR_AdministrativeCosts.pending, (state, action) => {
        state.loadingPRAdministrativeCosts = true;
        state.PRAdministrativeCosts = action.payload;
        state.errorPRAdministrativeCosts = null;
      })
      .addCase(GetPR_AdministrativeCostsByPR_AdministrativeCosts.fulfilled, (state, action) => {
        state.loadingPRAdministrativeCosts = false;
        state.PRAdministrativeCosts = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetPR_AdministrativeCostsByPR_AdministrativeCosts.rejected, (state, action) => {
        state.loadingPRAdministrativeCosts = false;
        state.errorPRAdministrativeCosts = action.payload;
      });
  },
});

export default PRAdministrativeCostsReducers.reducer;
